import React, { Fragment, useState, useEffect } from "react";
import { Alert, Box, Grid, MenuItem, Select, Snackbar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";

import {
  addDmpPlayersInMatch,
  clearDMPPlayersInMatch,
  getDmpLists,
  getSelectedDMPLeague,
} from "../../redux/actions/dmp-actions";
import { getAllLeaguePlayers } from "../../redux/actions/allLeaguePlayers-action";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  numberBox: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "8px",
    width: 30,
    minWidth: 30,
    borderRadius: "8px 0px 0px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  selectBox: {
    width: "100%",
    borderTop: "1px solid rgba(0, 0, 0, 0.42)",
    borderRight: "1px solid rgba(0, 0, 0, 0.42)",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
    borderRadius: "0px 8px 8px 0px",
    paddingLeft: "5px",
  },
});

const DmpCreate = ({ createdPlayerList, setToggleView, leagueId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // Selectors
  const playerList = useSelector((state) => state.leaguePlayerReducer.data);
  const aboutLeague = useSelector((state) => state.getDmpList.data);

  const addDmpPlayersSelector = useSelector(
    (state) => state.addDmpPlayersInMatchReducer
  );
  const selectedDMPSelector = useSelector(
    (state) => state.getSelectedDMPLeagueReducer
  );

  let no_of_teams = selectedDMPSelector?.data?.leageData
    ? selectedDMPSelector?.data?.leageData[0]?.season_description?.no_of_teams
    : 0;
  let getMatches = selectedDMPSelector?.data?.leageData[0]?.rounds[0]?.matches;

  // Local States
  const [allPlayers, setAllPlayers] = useState([]);
  const [teamGroups, setTeamGroups] = useState([]);
  const [showError, setShowError] = useState(false);
  const [holdAddedPlayers, setHoldAddedPlayers] = useState([]);

  const handleSelectedPlayer = (e, index, subIndex) => {
    let tempGroupsArr = [...teamGroups];

    if (tempGroupsArr[index][e.target.name] === null) {
      if (e.target.value === "Bye") {
        tempGroupsArr[index][e.target.name] = [];
        tempGroupsArr[index]["is_bye"] = e.target.name;
      } else {
        let tempArr = [{ user_id: e.target.value }];
        tempGroupsArr[index][e.target.name] = tempArr;

        if (e.target.name === tempGroupsArr[index].is_bye) {
          if (e.target.name === "group1") {
            if (tempGroupsArr[index]["group2"].length === 0) {
              tempGroupsArr[index]["is_bye"] = "group2";
            } else {
              delete tempGroupsArr[index]["is_bye"];
            }
          } else if (e.target.name === "group2") {
            if (tempGroupsArr[index]["group1"].length === 0) {
              tempGroupsArr[index]["is_bye"] = "group1";
            } else {
              delete tempGroupsArr[index]["is_bye"];
            }
          }
        }
      }
    } else {
      if (e.target.value === "Bye") {
        tempGroupsArr[index][e.target.name] = [];
        tempGroupsArr[index]["is_bye"] = e.target.name;
      } else {
        tempGroupsArr[index][e.target.name][subIndex] = {
          user_id: e.target.value,
        };
        if (e.target.name === tempGroupsArr[index].is_bye) {
          if (e.target.name === "group1") {
            if (tempGroupsArr[index]["group2"].length === 0) {
              tempGroupsArr[index]["is_bye"] = "group2";
            } else {
              delete tempGroupsArr[index]["is_bye"];
            }
          } else if (e.target.name === "group2") {
            if (tempGroupsArr[index]["group1"].length === 0) {
              tempGroupsArr[index]["is_bye"] = "group1";
            } else {
              delete tempGroupsArr[index]["is_bye"];
            }
          }
        }
      }
    }

    handleRemoveExistingPlayer(tempGroupsArr);
  };

  const handleRemoveExistingPlayer = (val) => {
    let filterSelectedPlayers = [];

    for (let a = 0; a < val.length; a++) {
      for (let b = 0; b < 2; b++) {
        if (b % 2 === 0) {
          if (val[a].group1 !== null) {
            val[a].group1.forEach((exists) => {
              filterSelectedPlayers.push(exists.user_id);
            });
          }
        } else {
          if (val[a].group2 !== null) {
            val[a].group2.forEach((exists) => {
              filterSelectedPlayers.push(exists.user_id);
            });
          }
        }
      }
    }

    setHoldAddedPlayers(filterSelectedPlayers);
  };

  const onSubmit = () => {
    let data = {};

    let checkIsBothBye = teamGroups.filter(
      (val) =>
        val.group1 !== null &&
        val.group1.length === 0 &&
        val.group1 !== null &&
        val.group2.length === 0
    );

    if (checkIsBothBye.length > 0) {
      toast.error("Both Players can't be BYE in the same group");
    } else {
      if (selectedDMPSelector.data?.leageData[0].rounds.length > 0) {
        data = {
          league_id: selectedDMPSelector.data?.leageData[0]?._id,
          round_id: selectedDMPSelector.data?.leageData[0]?.rounds[0]._id,
          matches: teamGroups,
        };
      } else {
        data = {
          league_id: selectedDMPSelector.data?.leageData[0]?._id,
          matches: teamGroups,
        };
      }

      dispatch(addDmpPlayersInMatch(data));
    }
  };

  useEffect(() => {
    if (leagueId != null) dispatch(getSelectedDMPLeague(leagueId));

    return () => {
      dispatch(clearDMPPlayersInMatch());
    };
  }, []);

  // UseEffects
  useEffect(() => {
    if (
      getMatches?.length > 0 &&
      getMatches !== null &&
      getMatches !== undefined
    ) {
      setTeamGroups(getMatches);
      handleRemoveExistingPlayer(getMatches);
    } else {
      let tempArr = [];

      for (let a = 0; a < no_of_teams / 2; a++) {
        tempArr.push({
          group1: null,
          group2: null,
        });
      }
      setTeamGroups(tempArr);
    }
    setAllPlayers(playerList);

    return () => {
      setTeamGroups([]);
    };
  }, [no_of_teams, playerList]);

  useEffect(() => {
    // sortedPlayerList(createdPlayerList.matches);
    if (playerList === undefined) {
      dispatch(getAllLeaguePlayers());
    }
    dispatch(getDmpLists());
  }, []);

  useEffect(() => {
    if (!addDmpPlayersSelector.loading) {
      if (Object.keys(addDmpPlayersSelector.data).length > 0) {
        if (!addDmpPlayersSelector.data.error) {
          toast.success(addDmpPlayersSelector.data.message);
          setToggleView(true);
        } else {
          setShowError(true);
        }
      }
    }
  }, [addDmpPlayersSelector]);

  return (
    <Fragment>
      {aboutLeague?.error === false && (
        <Fragment>
          {teamGroups.map((item, index) => {
            return (
              <Grid container spacing={2} key={index}>
                <Grid item xs={2.2}>
                  {/* Group 1  */}
                  {[...Array(Number(2))].map((val, ind) => (
                    <Box
                      sx={{
                        display: "flex",
                        width: "250px",
                        height: "50px",
                        mt: 1,
                        position: "relative",
                      }}
                      key={ind}
                    >
                      <Box className={classes.numberBox}>{index * 2 + 1}</Box>
                      <Select
                        variant="standard"
                        className={classes.selectBox}
                        disableUnderline
                        defaultValue=""
                        value={
                          item.group1 == null
                            ? ""
                            : item.group1.length === 0
                            ? "Bye"
                            : item.group1[ind]?.user_id
                        }
                        name="group1"
                        onChange={(e) => handleSelectedPlayer(e, index, ind)}
                      >
                        <MenuItem value="Bye">Bye</MenuItem>
                        {allPlayers?.map((val, i) => {
                          return (
                            <MenuItem
                              key={i}
                              value={val._id}
                              sx={{
                                display:
                                  holdAddedPlayers.indexOf(val._id) !== -1 &&
                                  "none",
                              }}
                            >
                              {val.first_name} {val.last_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Box>
                  ))}

                  {/* Group 2  */}
                  {[...Array(Number(2))].map((val, ind) => (
                    <Box
                      sx={{
                        display: "flex",
                        width: "250px",
                        height: "50px",
                        mt: 1,
                        position: "relative",
                        marginBottom: ind === 1 && "20px",
                      }}
                      key={ind}
                    >
                      <Box className={classes.numberBox}>{index * 2 + 2}</Box>
                      <Select
                        variant="standard"
                        className={classes.selectBox}
                        name="group2"
                        disableUnderline
                        defaultValue=""
                        value={
                          item.group2 == null
                            ? ""
                            : item.group2.length === 0
                            ? "Bye"
                            : item.group2[ind]?.user_id
                        }
                        onChange={(e) => handleSelectedPlayer(e, index, ind)}
                      >
                        <MenuItem value={"Bye"}>Bye</MenuItem>
                        {allPlayers?.map((val, i) => {
                          return (
                            <MenuItem
                              key={i}
                              value={val._id}
                              sx={{
                                display:
                                  holdAddedPlayers.indexOf(val._id) !== -1 &&
                                  "none",
                              }}
                            >
                              {val.first_name} {val.last_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Box>
                  ))}
                </Grid>
              </Grid>
            );
          })}

          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <Alert onClose={() => setShowError(false)} severity="error">
              {addDmpPlayersSelector?.data?.message}
            </Alert>
          </Snackbar>

          <Grid container spacing={2}>
            <Grid item xs={2.2}>
              <LoadingButton
                loading={addDmpPlayersSelector?.loading}
                fullWidth
                onClick={onSubmit}
                className={classes.saveBtn}
                sx={{
                  my: 2,
                  backgroundColor: "#06623B",
                  color: "#fff",
                  ":hover": { backgroundColor: "#06623B" },
                  ":disabled": { opacity: 0.6 },
                }}
              >
                Save
              </LoadingButton>
            </Grid>
          </Grid>
        </Fragment>
      )}
    </Fragment>
  );
};

export default DmpCreate;
